import React from 'react';
import WPLAYER from '../../../images/icon/WPLAYER.png';

const WPlayer = ({deviceTypeVersion, text, disabled}) => {
    let playerName = '';
    if (text) {
        playerName = 'W Player';
        //if (deviceTypeVersion > 0) {
        //    playerName += ' '+deviceTypeVersion;
        //}
    }
    return(
        <span className={"device_icon"}>
            {(
                ()=>{
                    switch(deviceTypeVersion) {
                        case 1:
                            return <img src={WPLAYER} style={{opacity : disabled ? 0.7 : 1, webkitFilter: disabled ? 'grayscale(100%)' : undefined}} data-deviceType={'WPLAYER'} data-deviceTypeVersion={deviceTypeVersion}/>
                    }
                }
            )()}
            {playerName}
        </span>
    )
}
export default WPlayer